import React from 'react';
import './Pagination.css';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  totalRecords: number;
}

const pageSizeOptions = [10, 25, 50, 100];

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  onPageSizeChange,
  totalRecords,
}) => {
  const getPageNumbers = () => {
    const pages: number[] = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = startPage + maxVisiblePages - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className="pgn-wrap">
      <div className="pgn-left">
        <span>Rows per page:</span>
        <select
          className="pgn-select"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
        <span className="pgn-info">
          {`${(currentPage - 1) * pageSize + 1}-${Math.min(
            currentPage * pageSize,
            totalRecords
          )} of ${totalRecords}`}
        </span>
      </div>

      <nav aria-label="Pagination">
        <ul className="pgn-nav">
          <li>
            <button
              className="pgn-btn"
              onClick={() => onPageChange(1)}
              disabled={currentPage === 1}
              title="First page"
            >
              «
            </button>
          </li>
          <li>
            <button
              className="pgn-btn"
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              title="Previous page"
            >
              ‹
            </button>
          </li>

          {getPageNumbers().map((page) => (
            <li key={page}>
              <button
                className={`pgn-btn ${currentPage === page ? 'active' : ''}`}
                onClick={() => onPageChange(page)}
              >
                {page}
              </button>
            </li>
          ))}

          <li>
            <button
              className="pgn-btn"
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              title="Next page"
            >
              ›
            </button>
          </li>
          <li>
            <button
              className="pgn-btn"
              onClick={() => onPageChange(totalPages)}
              disabled={currentPage === totalPages}
              title="Last page"
            >
              »
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
